import type { MessageKey } from './en';
import { en } from './en';

/**
 * Сообщения zod-схем форм — ключи словаря (`validation.required`). Незнакомое сообщение
 * (стандартный текст zod) заменяется общим, чтобы английский текст не попал в русский интерфейс.
 */
export function translateValidation(
  t: (key: MessageKey) => string,
  message: string | undefined,
): string | undefined {
  if (message === undefined) return undefined;
  return message in en ? t(message as MessageKey) : t('validation.invalid');
}
